import { render, staticRenderFns } from "./HorizontalInputs.vue?vue&type=template&id=0441370a&scoped=true"
import script from "./HorizontalInputs.vue?vue&type=script&lang=js"
export * from "./HorizontalInputs.vue?vue&type=script&lang=js"
import style0 from "./HorizontalInputs.vue?vue&type=style&index=0&id=0441370a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0441370a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0441370a')) {
      api.createRecord('0441370a', component.options)
    } else {
      api.reload('0441370a', component.options)
    }
    module.hot.accept("./HorizontalInputs.vue?vue&type=template&id=0441370a&scoped=true", function () {
      api.rerender('0441370a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/questionConfig/subViews/detail/components/HorizontalInputs.vue"
export default component.exports